import { ParamsClean } from '@/common/decorators/params-clean'
import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'


export interface RequestParams {
  /** 是否只查正版软件 0-否 1-是 */
  authenticsoft_flag?: number
}

export interface ResponseData {
   /** 今日活跃软件（今天有使用过的软件数量） */
  active_count?: number
  /** 已安装软件数(团队安装的软件数量) */
  install_count?: number
  /** 最高频率使用软件 */
  max_times_soft?: string
  /** 闲置软件（近7天未使用过的软件数量） */
  total_count?: number
}
export interface AuthenticRequestParams {
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
  /** 是否升序 */
  asc?: boolean
  /** 授权状态筛选：0-未授权 1-授权未生效 2-已授权 3-授权过期 */
  auth_status?: number
  /** 结束时间 */
  end_time?: number
  /** 软件分组id */
  soft_group_id?: number
  /** 软件名称模糊搜索 */
  soft_name?: string
  /** 排序字段 */
  sort?: string
  /** 开始时间 */
  start_time?: number
  /** 仅闲置正版列表：传 1 */
  idle_only?: number
}

export interface AuthenticList {
  /** 软件 hash（卸载等能力依赖；列表接口可能返回） */
  soft_hash_key?: string
  /** 软件 logo */
  logo_url?: string
  /** 软件名称 */
  soft_name: string
  /** 授权状态：0-未授权 1-授权未生效 2-已授权 3-授权过期 */
  auth_status: number
  /** 安装台数 */
  install_count: number
  /** 授权台数 */
  auth_count: number
  /** 软件id */
  soft_id: number
  /** 日均使用时长（分钟） */
  avg_duration?: number
  /** 日均使用次数 */
  avg_use_count?: number
  /** 软件安装时间（最新安装时间） */
  install_time?: number
  /** 最后活跃时间 */
  last_active_time?: number
  /** 软件版本号 */
  soft_version?: string
}

export interface AuthenticResponseData {
  /** 返回数据 */
  list: AuthenticList[]
  /** 总数 */
  total: number
  /** 当前页 */
  page: number
}
export interface AuthSoftResponseData {
  /** 已授权正版软件数（已创建授权的正版软件数量） */
  auth_soft_count?: number
  /** 未授权正版软件数（已发现且未授权的正版软件数量） */
  install_count?: number
  /** 最高频率使用软件（启动次数最多的正版软件） */
  max_times_soft?: string
  /** 闲置正版软件（近7天未使用过的软件数量） */
  total_count?: number
  /** 今日有软件变更的终端数（与「软件管理」页 soft-type-stat.update_count 语义一致，需后端返回） */
  update_count?: number
}
@Injectable()
export class SoftmgrAuthenticSoftStatService {
  constructor(private http: Http) { }
  getSoftmgrSoftUseStat(data: RequestParams) {
    return this.http.post<ResponseData>('/softmgr/soft-use-stat', data)
  }
  // 正版软件查询列表
  @ParamsClean()
  getSoftmgrAuthenticSoftList (data: AuthenticRequestParams) {
    return this.http.post<AuthenticResponseData>('/softmgr/authentic-soft/list', data)
  }
  // 正版软件使用分析统计

  getSoftmgrAuthSoftUseStat () {
    return this.http.post<AuthSoftResponseData>('/softmgr/auth-soft-use-stat', {})
  }
}
